import React from "react";
import { connect } from "react-redux";

import classes from "./Home.module.css";
import Row from "./Row";
import { getPopVideos, getChannels, getHomeVideos } from "../../Actions/index";
import Spinner from "../UI/Spinner";

class Home extends React.Component {
  test() {
    const home = this.props.home.data;
    let i = 0;
    for (let keys in home) {
      if (keys !== "Trending" && home[keys].data.length === 0)
        this.props.getHomeVideos(home[keys].videoCatId, keys);
      ++i;
      if (i === 6) break;
    }
  }
  componentDidMount() {
    if (this.props.code && !this.props.home.pageNum) {
      this.props.getPopVideos(this.props.code);
      this.props.getChannels(this.props.code);
    }
  }
  componentDidUpdate(preProps) {
    if (preProps.code !== this.props.code && !this.props.home.pageNum) {
      this.props.getPopVideos(this.props.code);
      this.props.getChannels(this.props.code);
    }
    if (preProps.home.pageNum !== this.props.home.pageNum) this.test();
  }

  render() {
    let Rows = [];
    if (!this.props.home.loading) {
      let i = 0;
      for (let keys in this.props.home.data) {
        Rows[i] = <Row title={keys} key={keys} />;
        i++;
        if (i === 6) break;
      }
    } else {
      const style = {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
      };
      Rows = <Spinner style={style} />;
    }
    return <div className={classes.Home}>{Rows}</div>;
  }
}

const mapStateToProps = state => {
  return {
    code: state.regionCode,
    home: state.home
  };
};

export default connect(
  mapStateToProps,
  { getPopVideos, getChannels, getHomeVideos }
)(Home);
